import * as type from './constant';

export const getPerformance = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getPerformanceSuccess = (payload, month, selfRole = '') => ({
  type: type.GET_SUCCESS,
  payload,
  month,
  selfRole,
});

export const getPerformanceError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addPerformance = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addPerformanceSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updatePerformance = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updatePerformanceSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deletePerformance = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deletePerformanceSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationPerformanceError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
